import {
  COOKIE_SERVICE,
  type CookieService,
  DATADOG_SERVICE,
  type DatadogService,
} from "@packages/common";
import type { AdobeService, FavoritesService } from "@packages/domain";
import { ADOBE_SERVICE, FAVORITES_SERVICE } from "@packages/domain";
import { createApi } from "@packages/query";
import { createApp } from "@webmotors/ioc";
import { CONFIG, type Config } from "@/config";
import { AppModule } from "./app.module";

const app = createApp(AppModule);

export const config = app.resolve<Config>(CONFIG);

export const cookieService = app.resolve<CookieService>(COOKIE_SERVICE);

export const datadogService = app.resolve<DatadogService>(DATADOG_SERVICE);

export const favoritesService =
  app.resolve<FavoritesService>(FAVORITES_SERVICE);

export const adobeService = app.resolve<AdobeService>(ADOBE_SERVICE);

export const { queryFn, queryKey } = createApi(app);

export default app;
